/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useUserStore from '../../../store/userStore/userStore';
import {hasUserRole, UserRole} from '../../../utils/commonFunctions';
import {yearSelect} from '../../../utils/FormUtils/yearSelect';
interface Response {
  key: string;
  name: string;
  email: string;
  auth0UserId: string;
  refUserId: string;
}

interface User {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  auth0UserId: string;
  refUserId: string;
}

const getEmployees = async (pagination: {
  page: number;
  pageSize: number;
  searchParam: string;
}): Promise<{users: Response[]; total: number}> => {
  const {page, pageSize, searchParam} = pagination;
  const token = useUserStore.getState().userToken;
  const {facility, refUserId} = useUserStore.getState().userDetails;
  const company = useCompanyStore.getState().companyId;
  const currentYear = yearSelect()?.[0]?.value;

  try {
    const res = await axios.request({
      method: CRUDMethods.GET,
      url: `${API_BASE_URL}${
        API_ENDPOINT_JSON.getEmployees
      }/${company}/${currentYear}/${refUserId ?? 'null'}${
        hasUserRole(UserRole.Company_Admin) ||
        hasUserRole(UserRole.Company_user)
          ? ''
          : `/${facility}`
      }`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {page, pageSize, searchParam}
    });
    const preparedData = res.data.data.users.map((user: User) => {
      return {
        ...user,
        key: user._id,
        name: `${user.firstName} ${user.lastName}`
      };
    });

    return {users: preparedData, total: res?.data?.data?.total};
  } catch (err) {
    return {users: [], total: 0};
  }
};
export default getEmployees;
